/**
 * @author Code Lai（赖传峰）
 * @email codelai@staritgp.com
 * @date 2019/11/22 19:30
 */
import { notification } from 'antd'

export default (err?: Error) => {
  if (!err) return
  notification.destroy()
  notification.warn({
    message: __('Notification'),
    description: err.message,
  })
}
